import { Injectable } from '@angular/core';
import { createEffect, ofType, Actions } from '@ngrx/effects';
import { Store } from '@ngrx/store';
// import { AppState } from '@capacitor/app';
import { setLoadingSpinner } from '../actions/shared.action';
import { catchError, exhaustMap, filter, map, mergeMap, of, tap, withLatestFrom } from 'rxjs';
import { ROUTER_NAVIGATION, RouterNavigatedAction } from '@ngrx/router-store';
import * as fromAccountActions from '././../actions/account.action'
import { APIResponse } from 'src/app/models/api-response.model';
import { AccountService } from 'src/app/services/account.service';
import { OfflineStorageService } from 'src/app/services/offline-storage.service';
import { AppState } from '../app.state';
import { ModalService } from 'src/app/services/modal.service';
import { Router } from '@angular/router';
import { getUserProfile } from '../selectors/account.selector';
import { AuthService } from 'src/app/services/auth.service';

@Injectable()
export class AccountEffects {

  getUserProfile$ = createEffect(
    ()=> this.actions$.pipe(
      ofType(fromAccountActions.getUserProfile),
      exhaustMap((action) => 
        this.accountService.userProfile().pipe(
          map((response)=>{
            this.store.dispatch(setLoadingSpinner({status : false}));
            return fromAccountActions.getUserProfileSuccess({data: response?.details})
          }),
          catchError((response)=>{
            this.store.dispatch(setLoadingSpinner({status : false}));
            return of(fromAccountActions.getUserProfileFailed({data : response?.error?.message}))
          })
        )
      )
    )
  );
  
  getUserProfileSuccess$ = createEffect(
    ()=> this.actions$.pipe(
        ofType(fromAccountActions.getUserProfileSuccess),
        tap(async (action) =>{
          await this.offlineStorageService.setObject('user', JSON.stringify(action.data));
          const user = action?.data;         
          
          const pagePermissionsMap: { [key: string]: string[] } = {
            reports: [
              'duplicate_check',
              'all_purpose_query',
              'registry_statistics',
              'transfer_report',
              'view_reports'
            ],
            application: ['encode', 'verify', 'application'],
            queue: ['view_only', 'encode', 'verify', 'queue'],
            database: ['view_only', 'encode', 'verify', 'database'],
            print: ['encode', 'verify', 'print_id'],
            voucher: ['manage_entities', 'manage_entity_agents', 'redeem'],
            aid: ['manage_entities', 'manage_entity_agents', 'redeem'],
            users: ['manage_users', 'agency', 'roles_permissions']
          };
          
          const page = Object.keys(pagePermissionsMap).find(pageKey =>
            pagePermissionsMap[pageKey].some(p => user.permissions.includes(p))
          );
          const dashboardPermissions = ['dashboard', 'view_only', 'encode', 'verify'];
          const canAccessDashboard = user.permissions?.some(p => dashboardPermissions.includes(p));

          if (canAccessDashboard) {
            this.router.navigate(['/home/dashboard']);
            return;
          }else{
            if (page) {
              this.router.navigate([`/home/${page}`]);
            } 
          }
        })
      ),
    { dispatch: false }
  );

  getUserProfileFailed$ = createEffect(
    ()=> this.actions$.pipe(
        ofType(fromAccountActions.getUserProfileFailed),
        tap(async (action) =>{
          if(action.data){
            const message = action.data;
            this.modalService.errorModal(message)
          } else{
            const message = 'Unkown error ocurred. Please try again later.'
            this.modalService.errorModal(message)
          }
        })
      ),
    { dispatch: false }
  );

  constructor(
    private actions$: Actions,
    private accountService: AccountService,
    private offlineStorageService: OfflineStorageService,
    private store: Store<AppState>,
    private modalService: ModalService,
    private router: Router,
    private authService: AuthService
  ) {}

}
